<ng-container *ngIf="entity">
    <app-document-summary-field *ngIf="entity.document else common" [documentSummary]="entity.document"
                                [matTooltip]="entity.comment">
    </app-document-summary-field>
    <ng-template #common>
        <ng-container *ngIf="entity.readableValues?.length > 0">
            <ng-container *ngIf="entity.readableValues?.length === 1 else multipleValues">
                <div *ngIf="entity.readableValues[0].isImage else defaultValue">
                    <img (click)="openImage(entity.readableValues[0].readableValue)" [matTooltip]="entity.comment" src="{{entity.readableValues[0].readableValue}}" alt="image"
                         class="img-thumbnail cursor-pointer"
                         [style.max-width.px]="imageMaxWidthPx"
                         [style.max-height.px]="imageMaxHeightPx">
                    <div *ngIf="entity.label">{{ entity.label }}</div>
                </div>
            </ng-container>
            <ng-template #defaultValue>
                <app-summary-field [label]="displayLabel ? entity.label: undefined"
                                   [value]="entity.readableValues[0].readableValue" *ngIf="!entity.readableValues[0].isDocument">
                </app-summary-field>
                <app-document-summary-field *ngIf="entity.readableValues[0].isDocument" [documentId]="+entity.readableValues[0].readableValue" [label]="entity.label"></app-document-summary-field>
            </ng-template>
            <ng-template #multipleValues>
                <app-summary-field [label]="entity.label">
                    <div class="d-flex gap-5 flex-wrap">
                        <ng-container *ngFor="let readableValue of entity.readableValues">
                            <app-summary-field>
                                <img (click)="openImage(readableValue.readableValue)" [matTooltip]="entity.comment" src="{{readableValue.readableValue}}" alt="image"
                                     class="img-thumbnail cursor-pointer"
                                     [style.max-width.px]="imageMaxWidthPx"
                                     [style.max-height.px]="imageMaxHeightPx"
                                     *ngIf="readableValue.isImage">
                                <ng-container *ngIf="!readableValue.isImage && readableValue.readableValue">
                                    {{readableValue.readableValue}},
                                </ng-container>
                            </app-summary-field>
                        </ng-container>
                    </div>
                </app-summary-field>
            </ng-template>
        </ng-container>
    </ng-template>
</ng-container>